<template>
  <div class="page-project-column-grid">
    <div
      v-for="(col, index) in grid.flat()"
      :key="index"
      class="page-project-column-grid__item"
      :class="{'--is-vertical': col.isVertical, '--is-text': col.type && col.type === 'text'}"
      
    >
     <template v-if="col.type === 'text'">
                 <PagesProjectColumnTextBlock :title="col.title" :text="col.text" class="--in-column-transition" />
              </template>
    <template v-else>
      <template
        v-if="
          col.linkVideo !== '' &&
          col.linkVideoPreview &&
          col.linkVideoPreview !== ''
        "
      >
        <PagesProjectIntro
          :preview="col.linkVideoPreview"
          :url="col.linkVideo"
        />
      </template>
      <template v-else>
        <WidgetVideo
          class="is-cover"
          v-if="col.isVideo"
          :videoUrl="col.linkVideo"
          :loop="true"
          :autoplay="true"
          :muted="true"
          :preload="'auto'"
        />
        <WidgetPicture
          class="is-cover"
          v-else
          :image="{ custom: col.image?.responsiveImage }"
          :lazyLoad="true"
          :alt="col.alt"
        />
      </template>
    </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesProjectColumnGrid',
}
</script>

<script setup>
const props = defineProps({
  grid: Array,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
